document.addEventListener('DOMContentLoaded', function() {
    console.log("Multi-step Form.js loaded");

    // Find the form element
    const formWrapper = document.querySelector('.form__form-wrapper');
    const formContainer = document.querySelector('.form__container');
    const form = document.querySelector('#multiStepForm');
    const formSteps = document.querySelectorAll('.form__step');
    const stepsContainer = document.querySelector('.form__steps-container');
    const nextButtons = document.querySelectorAll('.next-step');
    const prevButtons = document.querySelectorAll('.prev-step');
    const submitButton = document.querySelector('#submitForm');
    const consentCheckboxes = document.querySelectorAll('input[type="checkbox"]');
    const textareaCounter = document.querySelector('#textareaCounter');

    // Slider specific elements
    const stepIndicators = document.querySelectorAll('.form__step-indicator');
    const progressFill = document.querySelector('.form__progress-fill');

    // Slider state
    let transitionInProgress = false;
    let completedSteps = new Set();
    let lastIsDesktop = window.innerWidth >= 1024;

    function isDesktop() {
      return window.innerWidth >= 1024;
    }

    function clearDesktopStates() {
      formSteps.forEach(step => {
        step.classList.remove('form__step--current', 'form__step--next-preview', 'form__step--disabled');
      });
      // Reset transform when leaving desktop
      stepsContainer.style.transform = '';
    }

    if (!form) {
        console.error('Multi-step form not found');
        return;
    }

    let currentStep = 1;
    const totalSteps = formSteps.length;

    // Initialize form
    initializeForm();

    // Add event listeners
    nextButtons.forEach(button => {
        button.addEventListener('click', handleNextStep);
    });

    prevButtons.forEach(button => {
        button.addEventListener('click', handlePrevStep);
    });

    // Add consent checkbox listeners
    consentCheckboxes.forEach(checkbox => {
        checkbox.addEventListener('change', validateConsents);
    });

    // Add field focus listeners to clear errors
    addFieldErrorClearListeners();

    // Add real-time validation listeners
    addRealTimeValidationListeners();

    // Add step indicator listeners
    stepIndicators.forEach(indicator => {
        indicator.addEventListener('click', function(e) {
            e.preventDefault();
            const targetStep = parseInt(this.dataset.step);

            // Prevent clicking if step is disabled
            if (this.classList.contains('form__step-indicator--disabled')) {
                return;
            }

            // Allow going to previous completed steps
            if (targetStep < currentStep || completedSteps.has(targetStep)) {
                showStep(targetStep);
                return;
            }

            // For forward movement, validate current step first
            if (targetStep > currentStep) {
                const isValid = validateCurrentStep();

                if (isValid) {
                    // Mark current step as completed
                    completedSteps.add(currentStep);
                    showStep(targetStep);
                } else {
                    // Show validation error feedback
                    showValidationFeedback();
                    return; // Prevent navigation
                }
            } else {
                // Same step - just refresh
                showStep(targetStep);
            }
        });
    });

    // Add form submit listener
    form.addEventListener('submit', function(event) {
        event.preventDefault();

        if (validateCurrentStep()) {
            const formData = collectFormData(form);
            submitFormData(formData);
        }
    });

    // Add basic touch/swipe support
    let touchStartX = 0;
    let touchStartY = 0;

    stepsContainer.addEventListener('touchstart', function(e) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
    }, { passive: true });

    stepsContainer.addEventListener('touchend', function(e) {
        if (!e.changedTouches[0]) return;

        const touchEndX = e.changedTouches[0].clientX;
        const touchEndY = e.changedTouches[0].clientY;
        const deltaX = touchStartX - touchEndX;
        const deltaY = touchStartY - touchEndY;

        // Only trigger if horizontal swipe is more significant than vertical
        if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 50) {
            if (deltaX > 0 && currentStep < totalSteps) {
                // Swipe left - next step (but only if current step is valid)
                handleNextStep(e);
            } else if (deltaX < 0 && currentStep > 1) {
                // Swipe right - previous step (always allowed)
                handlePrevStep(e);
            }
        }
    }, { passive: false });

    window.addEventListener('resize', function() {
        const nowIsDesktop = isDesktop();

        // Only do the heavy work when crossing the breakpoint
        if (nowIsDesktop !== lastIsDesktop) {
          if (nowIsDesktop) {
            lastIsDesktop = true
            // Mobile -> Desktop
            // Recompute classes for two-step view and slide position
            updateStepClasses(currentStep);
            updateDesktopStepStates(currentStep);

            // Keep your 12.5% per step translation on desktop
            const translateX = -(currentStep - 1) * 12.5;
            if (currentStep < formSteps.length) {
                const prev = stepsContainer.style.transition;
                stepsContainer.style.transition = 'none';
                // force reflow
                void stepsContainer.offsetWidth;
                stepsContainer.style.transform = `translateX(${translateX}%)`;
            }
          } else {
            // Desktop -> Mobile
            // Remove desktop-only visuals and transform
            clearDesktopStates();
            updateStepClasses(currentStep);
            stepsContainer.style.transform = '';
          }

          // Recalc heights/indicators/buttons after layout settles
          requestAnimationFrame(() => {
            updateFormWrapperHeight(currentStep);
            updateProgressBar(currentStep);
            updateStepIndicators(currentStep);
            updateNextButtonState(currentStep);
          });

          lastIsDesktop = nowIsDesktop;
          return;
        }

        // If breakpoint didn't change, just keep things in sync lightly
        updateStepClasses(currentStep);
        updateFormWrapperHeight(currentStep);
      });


    /**
     * Initialize the form
     */
    function initializeForm() {
        showStep(1);
        validateConsents();
        updateStepIndicators(1);
        addDisabledStepBlocking();
        updateNextButtonState(1);
    }

    /**
     * Show specific step using slider animation
     */
    function showStep(stepNumber) {
        if (transitionInProgress) return;
        if (stepNumber < 1 || stepNumber > formSteps.length) return;

        transitionInProgress = true;

        // Update step classes
        updateStepClasses(stepNumber);

        // Update form wrapper height based on current step(s)
        updateFormWrapperHeight(stepNumber);

        // Each step is always 12.5% of container (50% of viewport)
        // Move by 12.5% increments regardless of screen size
        // Desktop shows 2 steps (100% viewport), Mobile shows 1 step (50% viewport is enough)
        const translateX = -(stepNumber - 1) * 12.5;

        // Apply transform to slide to the correct step
        // stepsContainer.style.transform = `translateX(${translateX}%)`;

        // Update step visual states for desktop two-step view
        const isDesktop = window.innerWidth >= 1024;
        if (isDesktop) {
            // Apply transform to slide to the correct step
            updateDesktopStepStates(stepNumber);

            if (stepNumber < formSteps.length) {
                stepsContainer.style.transform = `translateX(${translateX}%)`;
            }
        }

        // Update progress bar
        updateProgressBar(stepNumber);

        // Update step indicators
        updateStepIndicators(stepNumber);

        // Update current step
        currentStep = stepNumber;

        // Update next button state for new step
        updateNextButtonState(stepNumber);

        // Don't scroll on initialization - only scroll after user interaction
        if (currentStep !== 1 || Array.from(formSteps).some((_, index) => completedSteps.has(index + 1))) {
            const currentStepElement = document.querySelector(`.form__step[data-step="${stepNumber}"]`);
            if (currentStepElement) {
                currentStepElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        }

        // Allow next transition after animation completes
        setTimeout(() => {
            transitionInProgress = false;
        }, 500);
    }

    /**
     * Update form wrapper height based on current visible step(s)
     */
    function updateFormWrapperHeight(stepNumber) {
        const formWrapper = document.querySelector('.form__form-wrapper');
        if (!formWrapper) return;

        const formSteps = document.querySelectorAll('.form__step');
        const isDesktop = window.innerWidth >= 1024;
        let minHeight = 350;
        let maxHeight = minHeight;

        const getHeight = step =>
            step ? step.offsetHeight : 0;

        const currentStep = document.querySelector(`.form__step[data-step="${stepNumber}"]`);
        const nextStep = document.querySelector(`.form__step[data-step="${stepNumber + 1}"]`);

        if (isDesktop) {
            // If last step, don't recalc — just keep current height
            if (stepNumber >= formSteps.length) {
                return; // do nothing
            }
            maxHeight = Math.max(minHeight, getHeight(currentStep), getHeight(nextStep));
        } else {
            maxHeight = Math.max(minHeight, getHeight(currentStep));
        }

        formWrapper.style.height = `${maxHeight}px`;
    }

    /**
     * Update step classes (hidden, visible)
     */
    function updateStepClasses(currentStepNumber) {
        formSteps.forEach((step, index) => {
            const stepNumber = index + 1;

            if (stepNumber === currentStepNumber) {
                // Current step - visible
                step.classList.remove('form__step--hidden');
            } else {
                // All other steps - hidden on mobile, managed by desktop logic
                if (window.innerWidth < 1024) {
                    step.classList.add('form__step--hidden');
                } else {
                    // On desktop, show current + next step
                    if (stepNumber === currentStepNumber + 1) {
                        step.classList.remove('form__step--hidden');
                    } else {
                        step.classList.add('form__step--hidden');
                    }
                }
            }
        });
    }

    /**
     * Update desktop step visual states for two-step view
     */
    function updateDesktopStepStates(stepNumber) {
        // if (window.innerWidth < 1024) return; // Only apply on desktop

        // Remove all desktop state classes
        formSteps.forEach(step => {
            step.classList.remove('form__step--current', 'form__step--next-preview', 'form__step--disabled');
        });

        // Apply current step class
        const currentStepElement = document.querySelector(`.form__step[data-step="${stepNumber}"]`);
        if (currentStepElement) {
            currentStepElement.classList.add('form__step--current');
        }

        // Apply next-preview class to the next step (if it exists)
        const nextStepElement = document.querySelector(`.form__step[data-step="${stepNumber + 1}"]`);
        if (nextStepElement) {
            nextStepElement.classList.add('form__step--next-preview');

            // Check if current step is completed to determine if next step should be disabled
            const isCurrentStepCompleted = completedSteps.has(stepNumber);
            if (!isCurrentStepCompleted) {
                nextStepElement.classList.add('form__step--disabled');
            }
        }
    }

    /**
     * Add click blocking to disabled steps
     */
    function addDisabledStepBlocking() {
        formSteps.forEach(step => {
            step.addEventListener('click', function(event) {
                if (this.classList.contains('form__step--disabled')) {
                    event.preventDefault();
                    event.stopPropagation();
                }
            });
        });
    }

    /**
     * Update progress bar fill
     */
    function updateProgressBar(stepNumber) {
        const progressPercentage = (stepNumber / formSteps.length) * 100;
        progressFill.style.width = `${progressPercentage}%`;
    }

    /**
     * Update step indicators visual state
     */
    function updateStepIndicators(currentStep) {

        stepIndicators.forEach((indicator, index) => {
            const stepNumber = index + 1;

            // Remove all state classes
            indicator.classList.remove('form__step-indicator--active', 'form__step-indicator--completed', 'form__step-indicator--disabled');

            if (stepNumber === currentStep) {
                // Current step
                indicator.classList.add('form__step-indicator--active');
            } else if (completedSteps.has(stepNumber)) {
                // Completed steps (can be clicked)
                indicator.classList.add('form__step-indicator--completed');
            } else if (stepNumber < currentStep) {
                // Previous steps that weren't explicitly completed (can be clicked)
                indicator.classList.add('form__step-indicator--completed');
            } else if (stepNumber === currentStep + 1) {
                // Next immediate step (can be clicked if current step validates)
                // No special class - appears normal/accessible
            } else if (stepNumber > currentStep + 1) {
                // Future steps that can't be accessed yet (disabled)
                indicator.classList.add('form__step-indicator--disabled');
            }
        });
    }

    /**
     * Show validation feedback when step change is blocked
     */
    function showValidationFeedback() {
        const currentIndicator = document.querySelector(`.form__step-indicator[data-step="${currentStep}"]`);
        if (currentIndicator) {
            currentIndicator.classList.add('form__step-indicator--shake');
            setTimeout(() => {
                currentIndicator.classList.remove('form__step-indicator--shake');
            }, 500);
        }
    }

    /**
     * Handle next step button click
     */
    function handleNextStep(event) {
        event.preventDefault();

        if (validateCurrentStep()) {
            // Mark current step as completed
            completedSteps.add(currentStep);

            if (currentStep < totalSteps) {
                showStep(currentStep + 1);
                validateConsents(); // Re-validate consents when moving to step 8
            }
        } else {
            // Scroll to first error if validation fails
            scrollToFirstError();
        }
    }

    /**
     * Handle previous step button click
     */
    function handlePrevStep(event) {
        event.preventDefault();

        if (currentStep > 1) {
            showStep(currentStep - 1);
        }
    }

    /**
     * Validate current step
     */
    function validateCurrentStep() {
        clearStepErrors();

        const currentStepElement = document.querySelector(`.form__step[data-step="${currentStep}"]`);
        if (!currentStepElement) {
            return false;
        }

        const requiredFields = currentStepElement.querySelectorAll('input[required], select[required], textarea[required]');
        const radioGroups = currentStepElement.querySelectorAll('input[type="radio"]');
        const checkboxes = currentStepElement.querySelectorAll('input[type="checkbox"]');

        let isValid = true;

        // Validate required text inputs, selects, and textareas
        requiredFields.forEach(field => {
            if (!field.value.trim()) {
                showFieldError(field, 'To pole jest wymagane');
                isValid = false;
            }
        });

        // Validate radio button groups
        const radioGroupsMap = new Map();
        radioGroups.forEach(radio => {
            const name = radio.name;
            if (!radioGroupsMap.has(name)) {
                radioGroupsMap.set(name, []);
            }
            radioGroupsMap.get(name).push(radio);
        });

        radioGroupsMap.forEach((radios, name) => {
            if (name === 'teamAgeCategory') {
                const selected = form.querySelector('input[name="teamAgeCategory"]:checked');
                if (selected.value === 'false') {
                    showRadioFieldError(radios.find(r => r.value === 'true'), 'Aby zgłosić zespół do uczestnictwa w turnieju, każdy z zawodników musi mieć ukończone co najmniej 16 lat i maksymalnie 23 lata.');
                    isValid = false;
                }
            }
        });

        // Validate email fields
        const emailFields = currentStepElement.querySelectorAll('input[type="email"]');
        emailFields.forEach(field => {
            if (field.value.trim() && !isValidEmail(field.value)) {
                showFieldError(field, 'Wprowadź poprawny adres email');
                isValid = false;
            }
        });

        // Validate number fields (player age fields)
        const numberFields = currentStepElement.querySelectorAll('input[type="number"]');
        numberFields.forEach(field => {
            if (field.value.trim()) {
                const age = parseInt(field.value);
                // Check if it's a player age field (contains "teamPlayerAge" in the id)
                if (field.id.includes('teamPlayerAge')) {
                    if (isNaN(age) || age < 16 || age > 100) {
                        showFieldError(field, 'Zawodnik musi mieć minimum 16 lat');
                        isValid = false;
                    }
                } else {
                    // General age validation for other age fields
                    if (isNaN(age) || age < 1 || age > 100) {
                        showFieldError(field, 'Wprowadź poprawny wiek (1-100)');
                        isValid = false;
                    }
                }
            }
        });

        // Validate textarea character limit
        const textareas = currentStepElement.querySelectorAll('textarea');
        textareas.forEach(textarea => {
            if (textarea.value.length > 1000) {
                showFieldError(textarea, 'Maksymalnie 1000 znaków');
                isValid = false;
            }
        });

        return isValid;
    }

    /**
     * Validate email format
     */
    function isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    /**
     * Show field error
     */
    function showFieldError(field, message) {
        const fieldContainer = field.closest('.form__field');
        if (!fieldContainer) return;

        // Check if error already exists for this field
        const existingError = fieldContainer.querySelector('.field-error');
        if (existingError) {
            // Update existing error message
            existingError.textContent = message;
        } else {
            // Create new error element
            const errorElement = document.createElement('div');
            errorElement.className = 'field-error';
            errorElement.textContent = message;
            fieldContainer.appendChild(errorElement);
        }

        const container = field.closest('.form__input-wrapper');
        if (container) {
            container.style.borderColor = '#FF6769';
            container.style.boxShadow = '-4px 2px 8.2px #FF6769';
        }

        // For radio buttons, style the radio indicators
        if (field.type === 'radio') {
            const radioGroup = field.closest('.form__radio-group');
            if (radioGroup) {
                const radioIndicators = radioGroup.querySelectorAll('.form__radio-indicator');
                radioIndicators.forEach(indicator => {
                    indicator.style.borderColor = '#FF6769';
                    indicator.style.boxShadow = '-2px 2px 6.2px #FF6769';
                });
            }
        }

        updateFormWrapperHeight(currentStep);
    }

    /**
     * Show field error for specific radio button
     */
    function showRadioFieldError(field, message) {
        const fieldContainer = field.closest('.form__field');
        if (!fieldContainer) return;

        // Check if error already exists for this field
        const existingError = fieldContainer.querySelector('.field-error');
        if (existingError) {
            // Update existing error message
            existingError.textContent = message;
        } else {
            // Create new error element
            const errorElement = document.createElement('div');
            errorElement.className = 'field-error';
            errorElement.textContent = message;
            fieldContainer.appendChild(errorElement);
        }

        // Style only the specific radio button indicator
        if (field && field.type === 'radio') {
            const radioIndicator = field.nextElementSibling; // Get the indicator span
            if (radioIndicator && radioIndicator.classList.contains('form__radio-indicator')) {
                radioIndicator.style.borderColor = '#FF6769';
                radioIndicator.style.boxShadow = '-2px 2px 6.2px #FF6769';
            }
        }

        updateFormWrapperHeight(currentStep);
    }

    /**
     * Clear step errors
     */
    function clearStepErrors() {
        const currentStepElement = document.querySelector(`.form__step[data-step="${currentStep}"]`);
        if (!currentStepElement) return;

        const errorElements = currentStepElement.querySelectorAll('.field-error');
        const containers = currentStepElement.querySelectorAll('.form__input-wrapper');
        const radioIndicators = currentStepElement.querySelectorAll('.form__radio-indicator');

        errorElements.forEach(error => error.remove());
        containers.forEach(container => {
            container.style.borderColor = '';
            container.style.boxShadow = '';
        });
        radioIndicators.forEach(indicator => {
            indicator.style.borderColor = '';
            indicator.style.boxShadow = '';
        });
    }

    /**
     * Validate consents and enable/disable submit button
     */
    function validateConsents() {
        if (currentStep === 8) {
            const consent = document.querySelector('#consent');
            const consentImage = document.querySelector('#consentImage');

            if (consent && consentImage) {
                const bothChecked = consent.checked && consentImage.checked;

                if (bothChecked) {
                    submitButton.disabled = false;
                } else {
                    submitButton.disabled = true;
                }
            }
        }
    }

    /**
     * Collect all form data including dynamic player fields
     */
    function collectFormData(form) {
        const data = {
            email: form.querySelector('#email')?.value || '',
            teamName: form.querySelector('#teamName')?.value || '',
            teamAgeCategory: form.querySelector('input[name="teamAgeCategory"]:checked')?.value || '',
            teamDetails: form.querySelector('#teamDetails')?.value || '',
            players: [],
            teamGuardianName: form.querySelector('#teamGuardianName')?.value || '',
            teamGuardianPhone: form.querySelector('#teamGuardianPhone')?.value || '',
            teamGuardianEmail: form.querySelector('#teamGuardianEmail')?.value || '',
            consent: form.querySelector('#consent')?.checked || false,
            consentImage: form.querySelector('#consentImage')?.checked || false
        };

        // Collect dynamic player data
        let playerIndex = 1;
        while (form.querySelector(`#teamPlayerName_${playerIndex}`)) {
            const player = {
                name: form.querySelector(`#teamPlayerName_${playerIndex}`)?.value || '',
                age: form.querySelector(`#teamPlayerAge_${playerIndex}`)?.value || '',
                shoes: form.querySelector(`#teamPlayerShoes_${playerIndex}`)?.value || '',
                shorts: form.querySelector(`#teamPlayerShorts_${playerIndex}`)?.value || '',
                shirt: form.querySelector(`#teamPlayerShirt_${playerIndex}`)?.value || ''
            };

            data.players.push(player);
            playerIndex++;
        }

        return data;
    }

    /**
     * Submit form data to the server
     */
    async function submitFormData(data) {
        try {
            // Show loading state
            submitButton.disabled = true;
            submitButton.textContent = 'Wysyłanie...';

            const response = await fetch('/form-submit', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify(data)
            });

            if (response.ok) {
                const result = await response.json();
                handleSubmissionSuccess(result);
            } else {
                const errorData = await response.json().catch(() => ({}));
                handleSubmissionError(response.status, errorData);
            }
        } catch (error) {
            handleSubmissionError(0, { message: 'Network error occurred' });
        } finally {
            // Restore button state
            submitButton.disabled = false;
            submitButton.textContent = 'PRZEŚLIJ ZGŁOSZENIE';
        }
    }

    /**
     * Handle successful form submission
     */
    function handleSubmissionSuccess(result) {
        // Hide the form
        formWrapper.style.display = 'none';
        formContainer.classList.add('form-sent');
        updateStepIndicators(9);

        // Show success message
        const successDiv = document.createElement('div');
        successDiv.className = 'success-content';
        successDiv.innerHTML = `
            <div class="success-message">
                <h2>Dziękujemy za zgłoszenie!</h2>
                <p>Obecnie trwa jego weryfikacja. Na mail podany w formularzu przesłaliśmy potwierdzenie rejestracji.</p>
                <p> Nie widzisz maila? Sprawdź folder SPAM!</p>
                <p>1 września na stronie speedplayf50.pl opublikujemy listę zespołów zakwalifikowanych do turnieju. Dodatkowo, każda zakwalifikowana drużyna otrzyma potwierdzenie mailowe. Powodzenia!</p>
            </div>
            <a href="#nagrody" class="form__button form__button--primary">
                SPRAWDŹ NAGRODY
            </a>
        `;

        formWrapper.parentNode.appendChild(successDiv);
    }

    /**
     * Handle form submission errors
     */
    function handleSubmissionError(status, errorData) {
        // Clear existing error messages
        clearErrorMessages();

        if (status === 400 && errorData.errors) {
            // Handle validation errors with field-specific messages
            showValidationErrors(errorData.errors);
            return;
        }

        // Handle general errors
        let message = 'Wystąpił błąd podczas wysyłania formularza.';

        if (status === 400) {
            message = 'Dane formularza są nieprawidłowe. Sprawdź wprowadzone informacje.';
        } else if (status === 500) {
            message = 'Wystąpił błąd serwera. Spróbuj ponownie później.';
        } else if (status === 0) {
            message = 'Brak połączenia z internetem. Sprawdź połączenie i spróbuj ponownie.';
        }

        // Show general error message
        showGeneralError(message);
    }

    /**
     * Clear all existing error messages
     */
    function clearErrorMessages() {
        // Remove all existing error messages
        const existingErrors = form.querySelectorAll('.error-message, .field-error');
        existingErrors.forEach(error => error.remove());

        // Remove error classes from fields
        const containers = form.querySelectorAll('.form__input-wrapper');
        const radioIndicators = form.querySelectorAll('.form__radio-indicator');

        containers.forEach(container => {
            container.style.borderColor = '';
            container.style.boxShadow = '';
        });
        radioIndicators.forEach(indicator => {
            indicator.style.borderColor = '';
            indicator.style.boxShadow = '';
        });
    }

    /**
     * Show validation errors for specific fields
     */
    function showValidationErrors(errors) {

        for (const [fieldName, errorMessage] of Object.entries(errors)) {
            if (fieldName === 'players' && typeof errorMessage === 'object') {
                // Handle player-specific errors
                showPlayerErrors(errorMessage);
            } else {
                // Handle regular field errors
                showFieldErrorByName(fieldName, errorMessage);
            }
        }

        // Show general summary message
        const errorDiv = document.createElement('div');
        errorDiv.className = 'error-message';
        errorDiv.style.cssText = 'background: #FF6769; color: white; padding: 16px; border-radius: 4px; margin-bottom: 16px; text-align: center;';
        errorDiv.textContent = 'Proszę poprawić błędy w formularzu i spróbować ponownie.';
        form.insertBefore(errorDiv, form.firstChild);
    }

    /**
     * Show error for a specific field by name
     */
    function showFieldErrorByName(fieldName, errorMessage) {
        const field = form.querySelector(`#${fieldName}`);
        if (field) {
            showFieldError(field, errorMessage);
        }
    }

    /**
     * Show errors for player fields
     */
    function showPlayerErrors(playerErrors) {
        for (const [playerKey, playerErrorData] of Object.entries(playerErrors)) {
            if (typeof playerErrorData === 'object') {
                // Specific player field errors
                const playerNumber = playerKey.replace('player_', '');

                for (const [fieldName, fieldError] of Object.entries(playerErrorData)) {
                    const fieldId = `teamPlayer${fieldName.charAt(0).toUpperCase() + fieldName.slice(1)}_${playerNumber}`;
                    const field = form.querySelector(`#${fieldId}`);

                    if (field) {
                        showFieldError(field, `Gracz ${playerNumber}: ${fieldError}`);
                    }
                }
            }
        }
    }

    /**
     * Show general error message
     */
    function showGeneralError(message) {
        const errorDiv = document.createElement('div');
        errorDiv.className = 'error-message';
        errorDiv.style.cssText = 'background: #FF6769; color: white; padding: 16px; border-radius: 4px; margin-bottom: 16px; text-align: center;';
        errorDiv.textContent = message;

        form.insertBefore(errorDiv, form.firstChild);
    }

    /**
     * Add listeners to clear errors when fields are clicked/focused
     */
    function addFieldErrorClearListeners() {
        // Text inputs, textareas, selects
        const allInputs = form.querySelectorAll('input, textarea, select');
        allInputs.forEach(input => {
            input.addEventListener('focus', function() {
                clearFieldError(this);
            });
        });

        // Radio buttons
        const radioButtons = form.querySelectorAll('input[type="radio"]');
        radioButtons.forEach(radio => {
            radio.addEventListener('click', function() {
                clearFieldError(this);
            });
        });

        // Checkboxes
        const checkboxes = form.querySelectorAll('input[type="checkbox"]');
        checkboxes.forEach(checkbox => {
            checkbox.addEventListener('click', function() {
                clearFieldError(this);
            });
        });
    }

    /**
     * Clear error for a specific field
     */
    function clearFieldError(field) {
        // Clear input wrapper styling
        const container = field.closest('.form__input-wrapper');
        if (container) {
            container.style.borderColor = '';
            container.style.boxShadow = '';
        }

        // Clear radio button styling
        if (field.type === 'radio') {
            const radioGroup = field.closest('.form__radio-group');
            if (radioGroup) {
                const radioIndicators = radioGroup.querySelectorAll('.form__radio-indicator');
                radioIndicators.forEach(indicator => {
                    indicator.style.borderColor = '';
                    indicator.style.boxShadow = '';
                });
            }
        }

        // Remove error messages from the field container
        const fieldContainer = field.closest('.form__field');
        if (fieldContainer) {
            const errorElements = fieldContainer.querySelectorAll('.field-error');
            errorElements.forEach(error => error.remove());
        }
    }

    /**
     * Scroll to first error in current step
     */
    function scrollToFirstError() {
        const currentStepElement = document.querySelector(`.form__step[data-step="${currentStep}"]`);
        if (!currentStepElement) return;

        const firstError = currentStepElement.querySelector('.field-error');
        if (firstError) {
            firstError.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        }
    }

    /**
     * Add real-time validation listeners
     */
    function addRealTimeValidationListeners() {
        // Listen to all form inputs for changes
        const allInputs = form.querySelectorAll('input, textarea, select, checkbox');
        allInputs.forEach(input => {
            input.addEventListener('input', function() {
                // Real-time age validation
                if (this.type === 'number' && this.id.includes('teamPlayerAge')) {
                    validateAgeField(this);
                }
                if (this.id === 'teamGuardianPhone') {
                    let value = this.value.replace(/\D/g, ''); // remove non-digits
                    if (value.length > 3 && value.length <= 6)
                        value = value.slice(0, 3) + '-' + value.slice(3);
                    else if (value.length > 6)
                        value = value.slice(0, 3) + '-' + value.slice(3, 6) + '-' + value.slice(6, 9);
                    this.value = value;
                    validatePhoneField(this);
                }
                if (this.id === 'teamDetails') {
                    const currentLength = this.value.length;
                    textareaCounter.textContent = `${currentLength} / 1000`;
                    if (currentLength > 1000) {
                        textareaCounter.style.color = '#FF6769'
                        showFieldError(input, 'Możesz wpisać maksymalnie 1000 znaków.');
                    } else {
                        clearFieldError(input);
                        textareaCounter.style.color = 'white'
                    }
                }

                // Update next button state
                updateNextButtonState(currentStep);
            });

            input.addEventListener('change', function() {
                // Update next button state
                updateNextButtonState(currentStep);
            });
        });

        // Listen only to the teamAgeCategory radios
        const ageRadios = form.querySelectorAll('input[name="teamAgeCategory"]');

        ageRadios.forEach(radio => {
          radio.addEventListener('change', () => {
            updateNextButtonState(currentStep);

            const selected = form.querySelector('input[name="teamAgeCategory"]:checked');

            if (!selected || selected.value !== 'true') {
              showRadioFieldError(
                ageRadios[0],
                'Aby zgłosić zespół do uczestnictwa w turnieju, każdy z zawodników musi mieć ukończone co najmniej 16 lat i maksymalnie 23 lata'
              );
            } else {
              clearFieldError(ageRadios[0]);
            }
          });
        });
    }

    /**
     * Validate age field in real-time
     */
    function validateAgeField(field) {
        if (field.value.trim()) {
            const age = parseInt(field.value);
            if (field.id.includes('teamPlayerAge') && (isNaN(age) || age < 16 || age > 23)) {
                showFieldError(field, 'Aby zgłosić zespół do uczestnictwa w turnieju, każdy z zawodników musi mieć ukończone co najmniej 16 lat i maksymalnie 23 lata');
            } else {
                clearFieldError(field);
            }
        }
    }

    /**
     * Validate phone field in real-time
     */
    function validatePhoneField(field) {
        const phoneValue = field.value.trim();

        // Regex: exactly 9 digits, no spaces, no dashes
        const isValidPhone = /^[0-9]{3}-[0-9]{3}-[0-9]{3}$/.test(phoneValue);

        if (!isValidPhone) {
          showFieldError(field, 'Podaj prawidłowy numer telefonu (9 cyfr)');
        } else {
          clearFieldError(field);
        }
    }

    /**
     * Update next button state (enabled/disabled)
     */
    function updateNextButtonState(stepNumber) {
        const stepElement = document.querySelector(`.form__step[data-step="${stepNumber}"]`);
        if (!stepElement) return;

        const nextButton = stepElement.querySelector('.next-step');
        if (!nextButton) return;

        // Check if current step is valid
        const isStepValid = checkStepFieldsComplete(stepElement);

        if (isStepValid) {
            nextButton.disabled = false;
            nextButton.classList.remove('opacity-50', 'cursor-not-allowed');
        } else {
            nextButton.disabled = true;
            nextButton.classList.add('opacity-50', 'cursor-not-allowed');
        }
    }

    /**
     * Check if all required fields in step are complete
     */
    function checkStepFieldsComplete(stepElement) {
        const requiredFields = stepElement.querySelectorAll('input[required], select[required], textarea[required]');
        const radioGroups = stepElement.querySelectorAll('input[type="radio"]');

        // Check text inputs, selects, textareas
        for (let field of requiredFields) {
            if (!field.value.trim()) {
                return false;
            }
        }

        // Check radio button groups
        const radioGroupsMap = new Map();
        radioGroups.forEach(radio => {
            const name = radio.name;
            if (!radioGroupsMap.has(name)) {
                radioGroupsMap.set(name, []);
            }
            radioGroupsMap.get(name).push(radio);
        });

        for (let [name, radios] of radioGroupsMap) {
            const selected = radios.find(radio => radio.checked);

            if (!selected || selected.value !== 'true') {
                return false;
            }
        }

        return true;
    }
});
